import { render } from "./PlanoBasic.vue?vue&type=template&id=1fb3c68f&scoped=true"
import script from "./PlanoBasic.vue?vue&type=script&lang=js"
export * from "./PlanoBasic.vue?vue&type=script&lang=js"

import "./PlanoBasic.vue?vue&type=style&index=0&id=1fb3c68f&scoped=true&lang=css"
import "./PlanoBasic.vue?vue&type=style&index=1&id=1fb3c68f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb3c68f"]])

export default __exports__